// @flow
import type { ERROR_TYPE, POINT_TYPE, ID_TYPE } from './common';

export type BUS_TYPE = {
  id: number,
  name: string,
  plates: string,
  picture: ?string,
  location: { latitude: number, longitude: number }
}

export type BUS_FETCH_STARTED_TYPE = {
  type: 'BUS_FETCH_STARTED',
  payload: number
};
export const BUS_FETCH_STARTED = 'BUS_FETCH_STARTED';

export type BUS_FETCH_SUCCEED_TYPE = {
  type: 'BUS_FETCH_SUCCEED',
  payload: BUS_TYPE
};
export const BUS_FETCH_SUCCEED = 'BUS_FETCH_SUCCEED';

export type BUS_FETCH_FAILED_TYPE = {
  type: 'BUS_FETCH_FAILED',
  payload: ERROR_TYPE
};
export const BUS_FETCH_FAILED = 'BUS_FETCH_FAILED';

export type BUS_UPDATED_TYPE = {
  type: 'BUS_UPDATED',
  payload: {
    id: number,
    location: POINT_TYPE
  }
};
export const BUS_UPDATED = 'BUS_UPDATED';

export type BUS_UPDATED_LAST_CONNECTION_TYPE = {
  type: 'BUS_UPDATED_LAST_CONNECTION',
  payload: {
    id: number,
    location: number,
  }
};
export const BUS_UPDATED_LAST_CONNECTION = 'BUS_UPDATED_LAST_CONNECTION';

export type BUSES_REGISTERED_TYPE = {
  type: 'BUSES_REGISTERED',
  payload: {
    entities: {[number]: BUS_TYPE}
  }
};
export const BUSES_REGISTERED = 'BUSES_REGISTERED';

export type BUS_REMOVED_TYPE = {
  type: 'BUS_REMOVED',
  payload: number
};
export const BUS_REMOVED = 'BUS_REMOVED';

export type BUS_CREATE_STARTED_TYPE = {
  type: 'BUS_CREATE_STARTED',
  payload: BUS_TYPE
};
export const BUS_CREATE_STARTED = 'BUS_CREATE_STARTED';

export type BUS_CREATE_SUCCEED_TYPE = {
  type: 'BUS_CREATE_SUCCEED',
  payload: BUS_TYPE
};
export const BUS_CREATE_SUCCEED = 'BUS_CREATE_SUCCEED';

export type BUS_CREATE_FAILED_TYPE = {
  type: 'BUS_CREATE_FAILED',
  payload: ERROR_TYPE
};

export const BUS_CREATE_FAILED = 'BUS_CREATE_FAILED';

export type DELETE_BUS_STARTED_TYPE = {
  type: 'DELETE_BUS_STARTED',
  payload: number
};
export const DELETE_BUS_STARTED = 'DELETE_BUS_STARTED';

export type DELETE_BUS_SUCCESS_TYPE = {
  type: 'DELETE_BUS_SUCCESS',
  payload: {
    id: number
  }
};
export const DELETE_BUS_SUCCESS = 'DELETE_BUS_SUCCESS';

export type DELETE_BUS_FAILED_TYPE = {
  type: 'DELETE_BUS_FAILED',
  payload: ERROR_TYPE
};

export const DELETE_BUS_FAILED = 'DELETE_BUS_FAILED';

export type FETCH_SCHOOl_BUSES_STARTED_TYPE = {
  type: 'FETCH_SCHOOl_BUSES_STARTED',
  payload: {
    school: number,
    text?: string,
  }
};

export const FETCH_SCHOOl_BUSES_STARTED = 'FETCH_SCHOOl_BUSES_STARTED';

export type FETCH_SCHOOl_BUSES_SUCCESS_TYPE = {
  type: 'FETCH_SCHOOl_BUSES_SUCCESS',
  payload: {
    entities: {[number]: BUS_TYPE},
    order: Array<number>
  }
};
export const FETCH_SCHOOl_BUSES_SUCCESS = 'FETCH_SCHOOl_BUSES_SUCCESS';

export type FETCH_SCHOOl_BUSES_FAILED_TYPE = {
  type: 'FETCH_SCHOOl_BUSES_FAILED',
  payload: ERROR_TYPE
};
export const FETCH_SCHOOl_BUSES_FAILED = 'FETCH_SCHOOl_BUSES_FAILED';

export type BUS_SELECTED_TYPE = {
  type: 'BUS_SELECTED',
  payload: ID_TYPE,
};
export const BUS_SELECTED = 'BUS_SELECTED';

export type UPDATE_BUS_STARTED_TYPE = {
  type: 'UPDATE_BUS_STARTED',
  payload: Object
};
export const UPDATE_BUS_STARTED = 'UPDATE_BUS_STARTED';

export type UPDATE_BUS_FAILED_TYPE = {
  type: 'UPDATE_BUS_FAILED',
  payload: ERROR_TYPE
};

export const UPDATE_BUS_FAILED = 'UPDATE_BUS_FAILED';

export type UPDATE_BUS_SUCCEED_TYPE = {
  type: 'UPDATE_BUS_SUCCEED',
  payload: BUS_TYPE
};
export const UPDATE_BUS_SUCCEED = 'UPDATE_BUS_SUCCEED';

export type BUS_FILTERS_CHANGED_TYPE = {
  type: 'BUS_FILTERS_CHANGED',
  payload: string
}

export const BUS_FILTERS_CHANGED = 'BUS_FILTERS_CHANGED';

export type BUS_ACTION_TYPE =
  | BUS_FETCH_STARTED_TYPE
  | BUS_CREATE_STARTED_TYPE
  | FETCH_SCHOOl_BUSES_STARTED_TYPE
  | FETCH_SCHOOl_BUSES_SUCCESS_TYPE
  | FETCH_SCHOOl_BUSES_FAILED_TYPE
  | DELETE_BUS_STARTED_TYPE
  | DELETE_BUS_SUCCESS_TYPE
  | DELETE_BUS_FAILED_TYPE
  | BUS_CREATE_SUCCEED_TYPE
  | BUS_CREATE_FAILED_TYPE
  | BUS_REMOVED_TYPE
  | BUS_FETCH_SUCCEED_TYPE
  | BUS_FETCH_FAILED_TYPE
  | BUS_UPDATED_TYPE
  | BUSES_REGISTERED_TYPE
  | BUS_SELECTED_TYPE
  | UPDATE_BUS_FAILED_TYPE;



// WEBPACK FOOTER //
// ./src/scripts/types/buses.js